<template>
	<c-dialog ref="dialog" mode="slide" width="80vw" enable-flex mask-close :button="false">
		<template #head>
			<div v-if="oversold.oversold_no" class="m-detail-tag flex-center-cross">
				<label>{{oversold.oversold_no}}</label>
				<c-state tag async dict="OVERSOLD_HANDLE_STATE" :value="oversold.handle_state"></c-state>
			</div>
		</template>

		<!--取消订单弹框：填写取消原因后提交，后端强制必填并写入业务日志-->
		<c-dialog ref="cancelDialog" title="取消该订单" width="480">
			<div class="m-cancel-box">
				<p class="m-cancel-tip">确认取消订单【{{cancelingCard.order_no || ''}}】吗？取消后本机占用释放，超卖单将在重估后自动更新。</p>
				<p class="m-cancel-label">取消原因（必填）</p>
				<c-input v-model="cancelRemark" type="textarea" maxlength="500" :height-resize="{minHeight: '80px'}" placeholder="请填写取消原因，供后续核对"></c-input>
			</div>
			<template #button>
				<c-button size="dialog" color="red" :disabled="isCancelling" @click="submitCancel">确认取消</c-button>
				<c-button size="dialog" :disabled="isCancelling" @click="$refs.cancelDialog.close()">再想想</c-button>
			</template>
		</c-dialog>

		<module>
			<module-col size="400">
				<c-detail class="m-detail-form">
					<c-detail-item label="所属商户">
						{{oversold.saas_name || '-'}}
					</c-detail-item>
					<c-detail-item label="超卖单号">
						{{oversold.oversold_no || '-'}}
					</c-detail-item>
					<c-detail-item label="产品信息">
						<c-state v-if="oversold.product_level" tag async dict="LEVEL_TYPE" :value="oversold.product_level"></c-state>
						<span>{{oversold.product_name || '-'}}</span>
					</c-detail-item>
					<c-detail-item label="背贴码">
						{{oversold.produce_code || '-'}}
					</c-detail-item>
					<c-detail-item label="IMEI">
						{{oversold.imei || '-'}}
					</c-detail-item>
					<c-detail-item label="超卖占用单数">
						{{oversold.oversold_channel_count || '-'}}
					</c-detail-item>
					<c-detail-item label="最高销售价">
						{{formatPrice(oversold.max_sale_price)}}
					</c-detail-item>
					<c-detail-item label="处理状态">
						<c-state async dict="OVERSOLD_HANDLE_STATE" :value="oversold.handle_state"></c-state>
					</c-detail-item>
					<c-detail-item label="判定时间">
						{{oversold.create_date || '-'}}
					</c-detail-item>
					<template v-if="oversold.handle_state == 2">
						<c-detail-item label="保留渠道">
							{{oversold.confirm_channel_name || '-'}}
						</c-detail-item>
						<c-detail-item label="保留销售单号">
							{{oversold.confirm_order_no || '-'}}
						</c-detail-item>
						<c-detail-item label="保留订单销售价">
							{{formatPrice(oversold.confirm_sale_price)}}
						</c-detail-item>
						<c-detail-item label="预期结算金额">
							{{formatPrice(oversold.expect_settle_price)}}
						</c-detail-item>
						<c-detail-item label="处理人">
							{{oversold.handle_user_realname || '-'}}
						</c-detail-item>
						<c-detail-item label="处理时间">
							{{oversold.handle_date || '-'}}
						</c-detail-item>
						<c-detail-item label="处理备注">
							{{oversold.handle_remark || '-'}}
						</c-detail-item>
					</template>
				</c-detail>
			</module-col>

			<module-col>
				<div class="m-card-wrap">
					<p v-if="canHandle" class="m-card-tip">请从以下占用订单中选择一单保留（只记录保留结果，其余订单请另行通知商户处理）</p>
					<div
						v-for="card in channelCards"
						:key="card.sold_flag == 1 ? 'sold_' + card.confirm_lock_id : card.order_id"
						class="m-channel-card"
						:class="{'m-selected': canHandle && card.sold_flag != 1 && confirmOrderId == card.order_id, 'm-confirmed': card.confirm_flag == 1, 'm-sold-card': card.sold_flag == 1}"
						@click="selectCard(card)">
						<div class="m-card-head flex-center-cross">
							<span class="m-channel-name">{{card.channel_name || '-'}}</span>
							<c-state v-if="card.sold_flag != 1" tag async dict="SALES_ORDER_STATE" :value="card.order_state"></c-state>
							<span v-else class="m-sold-tag">已售出</span>
							<span v-if="card.confirm_flag == 1" class="m-confirm-flag">已确认保留</span>
						</div>
						<div class="m-card-body">
							<!--售出终态这一路：不是可处理的在途订单，仅说明超卖占用数里多出来那一路在哪里-->
							<template v-if="card.sold_flag == 1">
								<p><label>成交单号</label>{{card.order_no || '无（锁凭证售出，未回写订单）'}}</p>
								<p><label>成交价</label><span class="m-amount">{{formatPrice(card.sale_price)}}</span></p>
								<p><label>售出时间</label>{{card.sold_date || '-'}}</p>
							</template>
							<!--线下开单这一路：无三方单号/收货人/结算信息，展示客户与开单时间，可作为保留对象-->
							<template v-else-if="card.offline_flag == 1">
								<p><label>销售单号</label>{{card.order_no || '-'}}</p>
								<p><label>销售价</label><span class="m-amount">{{formatPrice(card.sale_price)}}</span></p>
								<p><label>客户</label>{{card.customer_name || '-'}}</p>
								<p><label>开单时间</label>{{card.create_date || '-'}}</p>
							</template>
							<template v-else>
								<p><label>销售单号</label>{{card.order_no || '-'}}（{{card.third_party_order_no || '-'}}）</p>
								<p><label>销售价</label><span class="m-amount">{{formatPrice(card.sale_price)}}</span>　预期结算 {{formatPrice(card.expect_settle_amount)}}</p>
								<p><label>收货人</label>{{card.receiver_name || '-'}}</p>
								<p><label>收货地址</label>{{card.receiver_address || '-'}}</p>
								<p><label>付款时间</label>{{card.pay_date || '-'}}</p>
							</template>
							<!--逐单取消：需有取消权限码，且仅对可取消、未被选为保留的在途单显示（与是否处理模式无关，只读详情也可取消）-->
							<p v-if="canCancel(card) && auth('b_ops_oversold_cancel')" class="m-cancel-row">
								<span class="m-cancel-link" @click.stop="cancelOrder(card)">取消该订单</span>
							</p>
						</div>
					</div>

					<!--处理备注（运营填写的说明，保存到超卖单上并在已处理后回显）-->
					<div v-if="canHandle" class="m-remark-wrap">
						<p class="m-remark-label">处理备注（必填）</p>
						<!--组件库 textarea 不认 rows 属性，行数用 height-resize 控制，120px 约四行-->
						<c-input v-model="handleRemark" type="textarea" maxlength="500" :height-resize="{minHeight: '120px'}" placeholder="请填写处理备注"></c-input>
					</div>
				</div>
			</module-col>
		</module>

		<template v-if="canHandle" #button>
			<c-button size="dialog" color="main" @click="submitHandle">确认处理</c-button>
			<c-button size="dialog" @click="closeDialog">取消</c-button>
		</template>
	</c-dialog>
</template>

<script>
	export default {
		name: 'oversoldDetail',

		props: {
			//是否为处理模式（可选择保留订单并提交）
			handleable: {
				type: Boolean,
				default: false
			}
		},

		data() {
			return {
				oversoldId: '',
				oversold: {},
				channelCards: [],
				confirmOrderId: '',
				handleRemark: '',
				cancelingCard: {},
				cancelRemark: '',
				isCancelling: false
			}
		},

		computed: {
			/*********当前是否可执行处理操作**********/
			canHandle() {
				return this.handleable && this.oversold.handle_state == 1;
			}
		},

		methods: {
			/*********打开抽屉**********/
			open(data = {}) {
				this.oversoldId = data.oversoldId;
				this.oversold = {};
				this.channelCards = [];
				this.confirmOrderId = '';
				this.handleRemark = '';
				this.$refs.dialog.open({title: this.handleable ? '超卖处理' : '超卖详情'});
				this.loadDetail();
			},

			/*********加载超卖详情（运营端接口，服务端先查这条超卖单属于哪个商户再组装返回）**********/
			loadDetail() {
				this.request({
					url: '/ops/oversold/sale/order/detail',
					data: {
						id: this.oversoldId
					},
					loading: true,
					success: data => {
						this.oversold = data.oversold || {};
						this.channelCards = data.channel_cards || [];
						//默认选中已确认保留的订单
						var confirmed = this.channelCards.find(item => item.confirm_flag == 1);
						if (confirmed) this.confirmOrderId = confirmed.order_id;
					}
				});
			},

			/*********选择保留订单（售出终态卡不可选，线上单与线下开单单均可选）**********/
			selectCard(card) {
				if (!this.canHandle || card.sold_flag == 1) return;
				this.confirmOrderId = card.order_id;
			},

			/*********能否取消该占用订单：线上单待收款或待发货可取消，线下单只有待收款可取消；已售出的和已勾选保留的不能取消**********/
			canCancel(card) {
				if (card.sold_flag == 1) return false;
				if (this.confirmOrderId && this.confirmOrderId == card.order_id) return false;
				if (card.offline_flag == 1) return card.order_state == 1;
				return card.order_state == 1 || card.order_state == 2;
			},

			/*********取消该占用订单：打开取消弹框让运营填写原因，后端强制必填并写业务日志**********/
			cancelOrder(card) {
				var merchant_id = this.oversold.saas_id;
				if (!merchant_id) {
					this.$message({message: '商户信息未加载，请刷新后重试', type: 'warn'});
					return;
				}
				this.cancelingCard = card;
				this.cancelRemark = '';
				this.$refs.cancelDialog.open();
			},
			/*********提交取消订单：带运营填写的原因调统一取消接口，成功后重载详情**********/
			submitCancel() {
				if (this.isCancelling) return;
				var remark = this.cancelRemark.trim();
				if (!remark) {
					this.$message({message: '请填写取消原因', type: 'warn'});
					return;
				}
				if (remark.length > 500) {
					this.$message({message: '取消原因不能超过500字', type: 'warn'});
					return;
				}
				var card = this.cancelingCard;
				if (card.order_id == this.confirmOrderId) this.confirmOrderId = '';
				this.isCancelling = true;
				this.request({
					url: '/sale/order/ops/cancel',
					data: {
						merchant_id: this.oversold.saas_id,
						order_id: card.order_id,
						cancel_source: 'oversold',
						remark: remark
					},
					loading: true,
					success: (data, msg) => {
						this.$refs.cancelDialog.close();
						this.$message({message: msg || '取消成功', type: 'success'});
						this.loadDetail();
					},
					complete: () => {
						this.isCancelling = false;
					}
				});
			},

			/*********格式化价格**********/
			formatPrice(price) {
				if (price === null || price === undefined || price === '') return '-';
				return '¥' + parseFloat(price).toFixed(2);
			},

			/*********确认处理**********/
			submitHandle() {
				if (!this.confirmOrderId) {
					this.$message({message: '请选择要保留的订单', type: 'warn'});
					return;
				}
				var remark = (this.handleRemark || '').trim();
				if (!remark) {
					this.$message({message: '请填写处理备注', type: 'warn'});
					return;
				}
				if (remark.length > 500) {
					this.$message({message: '备注内容不能超过500字', type: 'warn'});
					return;
				}
				this.request({
					url: '/ops/oversold/sale/order/handle',
					data: {
						id: this.oversoldId,
						confirm_order_id: this.confirmOrderId,
						handle_remark: remark
					},
					loading: true,
					success: (data, msg) => {
						this.$message({message: msg || '处理成功', type: 'success'});
						this.$refs.dialog.close();
						this.$emit('resolve');
					}
				});
			},

			/*********关闭抽屉**********/
			closeDialog() {
				this.$refs.dialog.close();
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.m-detail-tag {
		gap: 8px;
		font-size: 14px;
		font-weight: bold;
	}

	.m-card-wrap {
		flex: 1;
		padding: 10px;
		overflow-y: auto;
	}

	.m-card-tip {
		margin-bottom: 10px;
		font-size: 13px;
		color: #fa8c16;
	}

	/*逐单取消入口：卡片底部右对齐的红字链接*/
	.m-cancel-row {
		margin-top: 6px;
		padding-top: 8px;
		border-top: 1px dashed #f0f0f0;
		text-align: right;
		line-height: 22px;

		.m-cancel-link {
			font-size: 13px;
			color: #f5222d;
			cursor: pointer;
		}
	}

	.m-remark-wrap {
		margin-top: 16px;
		padding: 12px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		background: #fff;

		.m-remark-label {
			margin-bottom: 8px;
			font-size: 13px;
			font-weight: bold;
			color: #333;
		}
	}

	/*取消订单弹框内容区：带内边距的四边留白（嵌套 c-dialog 内容区默认无内边距）*/
	.m-cancel-box {
		padding: 16px 20px;

		.m-cancel-tip {
			margin-bottom: 14px;
			line-height: 22px;
			font-size: 13px;
			color: #666;
		}

		.m-cancel-label {
			margin-bottom: 8px;
			font-size: 13px;
			font-weight: bold;
			color: #333;
		}
	}

	.m-channel-card {
		margin-bottom: 12px;
		border: 1px solid #e8e8e8;
		border-radius: 4px;
		background: #fff;
		transition: border-color .2s, box-shadow .2s;

		&.m-selected {
			border-color: #1890ff;
			box-shadow: 0 0 0 2px rgba(24, 144, 255, .15);
		}

		&.m-confirmed {
			border-color: #52c41a;
		}

		/*售出终态卡：仅做说明不可操作，置灰虚线边与可处理卡片区分*/
		&.m-sold-card {
			background: #fbfbfb;
			border-style: dashed;
			border-color: #d9d9d9;
		}

		.m-card-head {
			gap: 8px;
			padding: 8px 12px;
			background: #fafafa;
			border-bottom: 1px solid #f0f0f0;

			.m-channel-name {
				font-size: 14px;
				font-weight: bold;
				color: #333;
			}

			.m-confirm-flag {
				margin-left: auto;
				font-size: 12px;
				color: #52c41a;
			}

			.m-sold-tag {
				padding: 0 6px;
				font-size: 12px;
				line-height: 20px;
				border-radius: 2px;
				color: #8c8e91;
				background: #f0f0f0;
			}
		}

		.m-card-body {
			padding: 8px 12px;
			line-height: 24px;
			font-size: 13px;
			color: #333;

			label {
				display: inline-block;
				width: 70px;
				color: #999;
			}

			.m-amount {
				font-weight: bold;
				color: #e53e3e;
			}

			.m-sold-desc {
				color: #fa8c16;
			}
		}
	}
</style>
